import React from "react";
import { ElementState, Preview } from "@creatomate/preview";
import { Trans } from "app/utils";
import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import UploadMedia from "./UploadMedia";
import AnimationButton from "../../animation/AnimationButton";
import AnimationBackButton from "../../animation/AnimationBackButton";
import DeleteButton from "../../../common/DeleteButton";

interface MediaHeaderProps {
  preview: Preview;
  activeElement: ElementState;
  mediaType: string;
  uploading: boolean;
  showBackHeader: boolean;
  setShowAnimations: (value: boolean) => void;
  onDelete: () => void;
  onMediaUploaded: (modifications: Record<string, any>) => {};
  onUploadingValue: (value: boolean) => void;
}

type MainHeaderProps = Omit<MediaHeaderProps, "showBackHeader" | "setShowAnimations"> & {
  onShowAnimations: () => void;
}

const MainHeader = ({
  preview,
  activeElement,
  mediaType,
  uploading,
  onShowAnimations,
  onDelete,
  onMediaUploaded,
  onUploadingValue
}: MainHeaderProps) => (
  <>
    <div className="Captions-Header__Title">
      <div className="Captions-Header__Actions">
        <h2><Trans>Edit Media</Trans></h2>
        {activeElement && (
          <DeleteButton preview={preview} element={activeElement} onDelete={onDelete} />
        )}
      </div>
      <div className="Add-Media">
        <UploadMedia
          preview={preview}
          mediaType={mediaType}
          uploading={uploading}
          onMediaUploaded={onMediaUploaded}
          onUploading={onUploadingValue}
        />
      </div>
    </div>

    {mediaType === VIDEO_TYPE && activeElement && (
      <AnimationButton onShowAnimations={onShowAnimations} />
    )}
  </>
);

const MediaHeader = ({
  showBackHeader,
  setShowAnimations,
  ...rest
}: MediaHeaderProps) => (
  <div>
    {showBackHeader
      ? (
        <div>
          <AnimationBackButton onBack={() => setShowAnimations(false)} />
        </div>
      )
      : <MainHeader {...rest} onShowAnimations={() => setShowAnimations(true)} />}
  </div>
);

export default MediaHeader;
